
import { generateNameSuggestionSuffix } from '@bingads-webui-campaign/audience-campaign-shared';
import { getBudgetRange } from '@bingads-webui-campaign-legacy/common-grid-config/budget/get-budget-range';
import { getDefaultLocationTargetsViewModel, getDefaultLanguagesViewModel } from '@bingads-webui-campaign-react/wizard-shared-components';
import { URL_RULES_OPTIONS } from '@bingads-webui-campaign-react/url-rules';
import { FLOWS } from '@bingads-webui-campaign-react/unified-app-shared';

const platformToAppStore = {
  Windows: 'MicrosoftAppStore',
  Android: 'GoogleAppStore',
  iOS: 'AppleAppStore',
};

const getBiddingScheme = (flow) => {
  const isFlowApps = flow !== FLOWS.WINDOWS;
  if (isFlowApps) {
    return {
      Type: 'ManualCpc',
      ManualCpc: 5,
    };
  }
  return {
    Type: 'ManualCpa',
    ManualCpi: 5,
  };
};

export const getDefaultCampaignData = ({
  serverContext,
  cnMarketAccount,
  AppSetting,
  flow,
}) => {
  let platformNamePrefix;
  if (flow !== FLOWS.WINDOWS) {
    platformNamePrefix = flow === FLOWS.ANDROID ? 'Android' : 'iOS';
  }
  return ({
    Name: `${generateNameSuggestionSuffix(flow === FLOWS.WINDOWS ? 'Windows Store Campaign' : `${platformNamePrefix} Mobile App Campaign`)}-${Math.floor(Math.random() * 100)}`,
    Status: 'Paused',
    Languages: getDefaultLanguagesViewModel(cnMarketAccount),
    Budget: {
      Amount: getBudgetRange(serverContext.CurrentAccount.CurrencyCode).Daily.Default,
      Type: 'DailyStandard',
    },
    BiddingScheme: getBiddingScheme(flow),
    CampaignType: 'App',
    CampaignSubType: 'AppInstall',
    locationTargets: getDefaultLocationTargetsViewModel(cnMarketAccount),
    AppStore: platformToAppStore[AppSetting?.AppPlatform],
    AppId: AppSetting?.AppStoreId,
    TrackingUrlTemplate: 'http://www.trackingtool.com/tracking?url={lpurl}&type=1',
    AppSetting,
  });
};

export const getDefaultAssetGroup = ({ i18n, businessName, storeFinalUrl = null }) => ({
  Name: generateNameSuggestionSuffix(i18n.getString(_TL_('AssetGroup'))),
  Status: 'Paused',
  Images: {
    ImageList: [],
    IsOptional: true,
  },
  BusinessName: businessName,
  FinalUrls: [storeFinalUrl],
  FinalUrlForRecommendation: storeFinalUrl,
  UrlRulesOption: URL_RULES_OPTIONS.All,
});
